import React, { Component } from 'react';
import { submit, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NewCustomerForm from '../../../shared-components/NewCustomerForm/NewCustomerForm';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { triggerEnsightenEvent } from '../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_SIGNUP_START, ENSIGHTEN_SIGNUP_FINISH } from '../../../framework/store/Ensighten/EnsightenConstants';
import { submitNewCustomerApplication } from './NewCustomerPageActions';
import { SIGN_UP_FORM_ID, FLOW_TYPE, CREDIT_TYPE } from '../../../framework/App/AppConstants';
import { CONTEXT_TYPE } from '../../../framework/App/SkeletonPage/SkeletonPageConstants';
import StickyContainer from '../../../shared-components/StickyContainer/StickyContainer';
import StickyBody from '../../../shared-components/StickyBody/StickyBody';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import Footer from '../../components/Footer/Footer';
import TwoColumnLayout from '../../../framework/components/Templates/TwoColumnLayout/TwoColumnLayout';
import BodyHeader from '../../../shared-components/BodyHeader/BodyHeader';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import Button, {BUTTON_STYLE} from '../../../shared-components/Button/Button';
import CancelUrl, { COMPONENT_STYLE } from '../../../GB/components/CancelUrl/CancelUrl';
import '../../styles/base-gb.less';
import './NewCustomerPage.less';

import {
    GB_PRIVACY_STATEMENT_URL,
    GB_MARKETING_TERMS_MORE_INFO_URL
} from '../../config/GBConstants';


const GB_KEY_PAYMENT_SERVICE_INFO_URL = 'https://www.paypal.com/uk/webapps/mpp/ua/servicedescription-full';
const GB_USER_AGREEMENT_URL = 'https://www.paypal.com/uk/webapps/mpp/ua/useragreement-full';

const LOCALE_PREFIX = 'GB/pages/NewCustomerPage/NewCustomerPage';

export class NewCustomerPage extends Component {
    static propTypes = {
        contextType: PropTypes.oneOf(Object.values(CONTEXT_TYPE)).isRequired,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)).isRequired,
        creditType: PropTypes.string.isRequired,
        formValues: PropTypes.object.isRequired,
        intl: intlShape.isRequired,
        onClickContinue: PropTypes.func.isRequired,
        submitCallback: PropTypes.func.isRequired,
        isMobile: PropTypes.bool,
        currentPage: PropTypes.string.isRequired,
        isMiniBrowser: PropTypes.bool,
        emailNotAvailable: PropTypes.bool,
        onComponentDidMount: PropTypes.func.isRequired,
        wireOnGDPR: PropTypes.bool.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    constructor(props) {
        super(props);

        this.state = {
            fixToBottom: false
        };
    }

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleSubmit = () => {
        const { submitCallback, formValues } = this.props;
        return submitCallback({ ...formValues });
    };

    render() {
        const { onClickContinue, wireOnGDPR } = this.props;

        const termsLabel = (
            <FormattedHTMLMessage
                id={`${LOCALE_PREFIX}.ppTerms.agreeToTerms`}
                values={{
                    keyPaymentServiceInfoUrl: GB_KEY_PAYMENT_SERVICE_INFO_URL,
                    privacyPolicyUrl: GB_PRIVACY_STATEMENT_URL,
                    userAgreementUrl: GB_USER_AGREEMENT_URL
                }}
            />
        );

        const newCustomerFormProps = {
            initialValues: {
                marketingTerms: true
            },
            onSubmit: this.handleSubmit,
            showRequiredCheckbox: true,
            termsCheckboxLabel: termsLabel
        };

        // GDPR: "marketing terms"
        if (wireOnGDPR) {
            const bmlUKMarketingTerms = (
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.ppTerms.agreeToMarketingTerms`}
                    values={{
                        marketingMoreInfoUrl: GB_MARKETING_TERMS_MORE_INFO_URL
                    }}
                />
            );

            newCustomerFormProps.termsMarketingCheckboxLabel = bmlUKMarketingTerms;
        }

        return (
            <TwoColumnLayout pageName="NewCustomerPage">
                <BodyHeader />
                <StickyContainer>
                    <StickyBody>
                        <NewCustomerForm {...newCustomerFormProps} />
                    </StickyBody>
                    <StickyFooter fixToBottom={false} fadedBackground={true}>
                        <div id="action-buttons" className="vx_btn-group">
                            <Button
                                data-automation-id="continue"
                                btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                id="newCustomerContinueBtn"
                                onClick={onClickContinue}
                            >
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.continue-application`}
                                />
                            </Button>
                            <CancelUrl
                                componentType={COMPONENT_STYLE.LINK_BUTTON}
                                fptiEvent={{
                                    stateName: 'pp_credit_newcustpage',
                                    transitionName: 'cancel_pp_credit_newcustpage'
                                }}
                            />
                        </div>
                    </StickyFooter>
                </StickyContainer>
            </TwoColumnLayout>
        );
    }
}

export const mapStateToProps = state => {
    const isMiniBrowser = !!(_.get(state, 'serverData.contextType', '') === CONTEXT_TYPE.MB_CONTEXT);
    const emailNotAvailable = _.get(state, 'serverData.validationErrorModel.errors.emailNotAvailable');

    return {
        contextType: _.get(state, 'serverData.contextType'),
        flow: _.get(state, 'serverData.flow'),
        creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
        user: state.serverData.user,
        formValues: getFormValues(SIGN_UP_FORM_ID)(state) || {},
        financingDetails: state.serverData.financingDetails || {},
        merchantName: state.serverData.merchantName,
        isMobile: _.get(state, 'serverData.isMobile', false),
        currentPage: state.skeletonPage.currentPage,
        isMiniBrowser,
        emailNotAvailable,
        wireOnGDPR: _.get(state, 'serverData.featureFlags.wireOnGDPR', false)
    };
};


export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_newcustpage', 'prepare_pp_credit_newcustpage'));
        dispatch(triggerEnsightenEvent(ENSIGHTEN_SIGNUP_START));
    },
    onClickContinue() {
        dispatch(submit(SIGN_UP_FORM_ID));
    },
    submitCallback(formValues) {
        dispatch(spinnerOpen());
        dispatch(trackTransition('pp_credit_newcustpage', 'process_pp_credit_newcustpage'));
        dispatch(triggerEnsightenEvent(ENSIGHTEN_SIGNUP_FINISH));
        return dispatch(submitNewCustomerApplication(formValues, LOCALE_PREFIX));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NewCustomerPage));
